import useRootStore from './useRootStore';

export default function useSearchPlaces() {
  const { searchPlacesStore } = useRootStore();
  return searchPlacesStore;
}
